<script setup lang="ts">
import MovieCsfdPeopleItem from "./MovieCsfdPeopleItem.vue";
import MovieCsfdItem from "./MovieCsfdItem.vue";

type TProps = {
  movie: Record<string, any>;
};

const props = defineProps<TProps>();
</script>

<template>
  <div class="flex flex-col gap-y-4 md:gap-y-6">
    <div class="flex flex-col md:flex-row gap-y-4 md:gap-y-0 gap-x-13">
      <MovieCsfdPeopleItem
        :people="props.movie?.CSFD?.[0]?.Directors ?? []"
        :label="$getTranslate('movie_detail_content_title_direction')"
      />

      <MovieCsfdPeopleItem
        :people="props.movie?.CSFD?.[0]?.Screenwriters ?? []"
        :label="$getTranslate('movie_detail_content_title_screenplay')"
      />

      <MovieCsfdPeopleItem
        :people="props.movie?.CSFD?.[0]?.Composers ?? []"
        :label="$getTranslate('movie_detail_content_title_music')"
      />
    </div>

    <MovieCsfdPeopleItem
      :people="props.movie?.CSFD?.[0]?.Actors ?? []"
      :label="$getTranslate('movie_detail_content_title_cast')"
    />

    <div
      class="flex flex-col 2xs:flex-row gap-y-4 md:gap-y-0 gap-x-10 md:gap-x-13"
    >
      <MovieCsfdItem
        :label="$getTranslate('movie_detail_content_title_original_name')"
      >
        <div
          class="flex gap-x-1 text-2xs/4 md:text-sm font-secondary w-fit py-0.5"
        >
          {{ movie?.Title2Array ?? movie?.TitleArray }}
        </div>
      </MovieCsfdItem>

      <MovieCsfdItem
        :label="$getTranslate('movie_detail_content_title_origin')"
      >
        <div v-if="movie?.CSFD?.[0]?.Origins.trim().length > 0">
          <div class="text-2xs/4 md:text-sm font-secondary w-fit py-0.5">
            {{ movie.CSFD[0].Origins.trim().replace(",", " / ") }}
          </div>
        </div>
      </MovieCsfdItem>

      <MovieCsfdItem :label="$getTranslate('premiere_label')">
        <div
          class="flex gap-x-1 text-2xs/4 md:text-sm font-secondary w-fit py-0.5"
        >
          {{ new Date(movie?.Premiere).toLocaleDateString() }}
        </div>
      </MovieCsfdItem>
    </div>
  </div>
</template>
